import React, { Component } from 'react';
import { Switch, Route, useLocation } from "react-router-dom";
//import dropdown for bootstrap dropdown work.
import { Dropdown } from 'bootstrap';
import SignIn from './component/signin/SignIn';
import SignInStart from './component/signInStart/signInStart';
import SignInEnd from './component/SignInEnd/SignInEnd';
import { PrivateRoute } from './component/PrivateRoute/PrivateRoute';
import CoursePlayer from './component/CoursePlayer/CoursePlayer';
import CourseDetails from './component/CourseDetails/CourseDetails'
import MyLearning from './component/MyLearnings/MyLearnings';
import Catalog from './component/Catalog/Catalog'
import Header from './common/Header/Header';
import Footer from './common/Footer/footer'
import Profile from './component/Profile/Profile';
import HomeContainer from './component/HomePage/homeContainer';

//test
function App(props) {
  const location = useLocation();
  return (
    <React.Fragment>
      <div className="App">
        {/* <Header /> */}
        {location.pathname === '/course-player' ? null : <Header />}
        <Switch>
          <Route path="/sign-in/sign-in-start" component={SignInStart} />
          <Route path="/sign-in/sign-in-end" component={SignInEnd} />
          <Route path="/login" component={SignIn} />
          <PrivateRoute path="/course-details" component={CourseDetails} />
          <PrivateRoute path="/my-learning" component={MyLearning} />
          <PrivateRoute path="/catalog" component={Catalog} />
          <PrivateRoute path="/course-player" component={CoursePlayer} />
          <PrivateRoute path="/profile" component={Profile} />
          <PrivateRoute exact path="/" component={HomeContainer} />
        </Switch>
        {location.pathname === '/course-player' || location.pathname === '/sign-in' ? null : <Footer />}
      </div>
    </React.Fragment >
  );
}

export default App;